<script >
export default {
  name: 'Course3',

  created() {
    document.title = '国之重器——北京正负电子对撞机'
  }

}
</script>

<template>
  <iframe src="/dzj/start.html" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
</template>

<style scoped lang="less">
iframe {
  width: 100%;
  height: 100%;
}
</style>